// @ts-strict-ignore
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { LoggingService } from './logging.service';
import { MessageService } from './message.service';
import { RouteReloadService } from './route-reload-service';

export enum ErrorType {
  VARIABLES_LOAD,
  VARIABLE_SAVE,
  BOARD_SAVE,
  BOARD_LOAD,
  REDUCTION_GOAL_SAVE,
  MIGRATION_STATUS_MISMATCH,
  MIGRATION_LOCK,
  INVENTORY_EXPORT,
  INVENTORY_IMPORT,
  INVENTORIES_LOAD,
  INVENTORIES_SAVE,
  INVENTORIES_PROCESSING,
  INTERVENTION_CREATE,
  INTERVENTION_SHARE,
  INTERVENTIONS_EXPORT,
  INTERVENTIONS_IMPORT,
}

function isHttpErrorResponse(error: Error): error is HttpErrorResponse {
  return error.name === 'HttpErrorResponse';
}

@Injectable()
export class ErrorHandlerService extends Sentry.SentryErrorHandler implements ErrorHandler {
  apiUrls: string[];

  constructor(
    private _injector: Injector,
    private _routeReloadService: RouteReloadService
  ) {
    super();
  }

  handleError(error: any): void {
    super.handleError(error);
    console.error(error);
    this._injector.get(LoggingService)?.logException(error);
    this._routeReloadService.prepareRouteForReload();
    this._considerOpeningErrorDialog(error);
  }

  private _considerOpeningErrorDialog(error: any): void {
    if (
      !isHttpErrorResponse(error) ||
      !this.apiUrls.length ||
      (!this.apiUrls.some((url) => error.url?.includes(url)) &&
        !JSON.stringify(error, Object.getOwnPropertyNames(error)).includes('ChunkLoadError'))
    ) {
      return;
    }

    switch (error.status) {
      case 412:
        error['errorType'] = ErrorType.MIGRATION_STATUS_MISMATCH;
        break;
      case 423:
        error['errorType'] = ErrorType.MIGRATION_LOCK;
        break;
    }

    const messageService = this._injector.get(MessageService);
    messageService?.openErrorDialog(error);
  }
}
